export enum vatVerifiedEnum {
  PENDING = 'pending',
  UNAVAILABLE = 'unavailable',
  UNVERIFIED = 'unverified',
  VERIFIED = 'verified',
  EXONERATED = 'exonerated',
}
